// extracted by mini-css-extract-plugin
module.exports = {"characteristics":"characteristics__2LuIW","title":"title__3eF6H","item":"item__25evD","name":"name__2tdiU","value":"value__3mm6F"};